import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { maybeWaitForPremiumModal } from './maybeWaitForPremiumModal.tsx';
import type { Props, State } from './GlobalFieldsTourSteps.types.tsx';
import { CARD_COVERS_SPOTLIGHT } from './cardCoversSpotlight.constants.tsx';

export const loadCardCoverSpotlightState =
	(): Action<State, Props, Promise<void>> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		await maybeWaitForPremiumModal(getState);

		// User property is already loaded
		if (typeof getState().cardCoverSpotlight.spotlightDismissed === 'boolean') {
			return;
		}

		try {
			const spotlightDismissed = await getUserProperty<boolean>(accountId, CARD_COVERS_SPOTLIGHT);

			const state = getState();

			setState({
				...state,
				cardCoverSpotlight: {
					spotlightDismissed,
				},
			});
		} catch (error) {
			// Expected error, the property is not set yet
			if (error instanceof FetchError && error.statusCode === 404) {
				const state = getState();

				setState({
					...state,
					cardCoverSpotlight: {
						spotlightDismissed: false,
					},
				});

				return;
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.card-cover-spotlight',
				`Failed to get user property with key: ${CARD_COVERS_SPOTLIGHT}`,
				error instanceof Error ? error : new Error(String(error)),
			);
		}
	};
